import {Mapper} from '@s-ui/domain'

export class FromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper extends Mapper {
  constructor({relatedVehiclesListValueObjectFactory, relatedVehicleValueObjectFactory}) {
    super()
    this._relatedVehiclesListValueObjectFactory = relatedVehiclesListValueObjectFactory
    this._relatedVehicleValueObjectFactory = relatedVehicleValueObjectFactory
  }

  map = ({items}) => {
    const relatedVehiclesValueObjects = items.map(item => {
      const {doors, imageUrl, make, model, url, makeId, modelId} = item
      return this._relatedVehicleValueObjectFactory({
        doors,
        imageUrl,
        make,
        makeId,
        model,
        modelId,
        url
      })
    })
    return this._relatedVehiclesListValueObjectFactory({
      items: relatedVehiclesValueObjects
    })
  }
}
